import React, { useState, useRef } from 'react';
import './UploadTile.css';
import { Abbrechen } from '../../icons';

export function UploadTile({ accept, icon, selectLabel, changeLabel, onUpload, uploading, disabled }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileSelect = () => fileInputRef.current?.click();

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) setSelectedFile(file);
    e.target.value = '';
  };

  const handleRemoveFile = () => setSelectedFile(null);

  return (
    <div className="card card-large">
      <div className="card-large-content tile-content">
        <input
          ref={fileInputRef}
          type="file"
          accept={accept}
          className="upload-tile-file-input"
          onChange={handleFileChange}
          disabled={disabled}
        />
        {!selectedFile ? (
          <>
            <div className="tile-icon" aria-hidden="true">{icon}</div>
            <div className="action-buttons">
              <div className="device-actions tile-actions">
                <button
                  type="button"
                  onClick={handleFileSelect}
                  aria-label={selectLabel}
                  title={selectLabel}
                  disabled={disabled}
                  aria-disabled={disabled}
                >
                  {selectLabel}
                </button>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="tile-icon" aria-hidden="true">
              {uploading
                ? <span className="upload-tile-spinner" aria-hidden="true"><span className="upload-tile-spinner-ring" /></span>
                : '⬆️'}
            </div>
            <div className="upload-tile-file-info">
              <span className="upload-tile-file-label">Ausgewählte Datei:</span>
              <div className="selected-badges">
                <span className="selected-badge">
                  {selectedFile.name}
                  <button
                    type="button"
                    className="badge-remove"
                    aria-label="Datei entfernen"
                    title="Datei entfernen"
                    onClick={handleRemoveFile}
                    disabled={uploading}
                  ><Abbrechen/></button>
                </span>
              </div>
            </div>
            <div className="action-buttons">
              <div className="device-actions tile-actions">
                <button
                  type="button"
                  onClick={() => onUpload && onUpload(selectedFile)}
                  aria-label="Datei hochladen"
                  title="Datei hochladen"
                  disabled={uploading}
                >
                  {uploading ? 'Wird analysiert…' : 'Datei hochladen'}
                </button>
                <button
                  type="button"
                  className="upload-tile-btn-secondary"
                  onClick={handleFileSelect}
                  aria-label={changeLabel}
                  title={changeLabel}
                  disabled={uploading}
                >
                  {changeLabel}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
